export const AUTH_LOGIN_ROLES = [
  "super_admin",
  "admin",
  "merchant",
] as const;

export type AuthLoginRole = (typeof AUTH_LOGIN_ROLES)[number];
